var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgText(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h64v64H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64 56a8 8 0 01-8 8H8a8 8 0 01-8-8V8a8 8 0 018-8h48a8 8 0 018 8v48zm-8.205-39.59h-4.923v31.18h4.923V16.41z",
    fill: "#E6E7E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.891 0H7.984A7.984 7.984 0 000 7.984v47.907a7.962 7.962 0 003.315 6.467L62.358 3.315A7.967 7.967 0 0055.891 0",
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#545874",
    d: "M19.416 47.707h4.227l.234-31.414h-9.568l-.234 5.977h-5.87l.235-10.784h37.272l.235 10.784H40.08l-.235-5.977h-9.392l-.235 31.414h4.755v4.807H19.416z"
  })))));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjQiIGhlaWdodD0iNjQiIHZpZXdCb3g9IjAgMCA2NCA2NCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxwYXRoIGQ9Ik0wIDBoNjR2NjRIMHoiLz48ZyBmaWxsLXJ1bGU9Im5vbnplcm8iPjxwYXRoIGQ9Ik02NCA1NmE4IDggMCAwIDEtOCA4SDhhOCA4IDAgMCAxLTgtOFY4YTggOCAwIDAgMSA4LThoNDhhOCA4IDAgMCAxIDggOHY0OHptLTguMjA1LTM5LjU5aC00LjkyM3YzMS4xOGg0LjkyM1YxNi40MXoiIGZpbGw9IiNFNkU3RTgiLz48cGF0aCBkPSJNNTUuODkxIDBINy45ODRBNy45ODQgNy45ODQgMCAwIDAgMCA3Ljk4NHY0Ny45MDdhNy45NjIgNy45NjIgMCAwIDAgMy4zMTUgNi40NjdMNjIuMzU4IDMuMzE1QTcuOTY3IDcuOTY3IDAgMCAwIDU1Ljg5MSAwIiBmaWxsPSIjRjRGNEY0Ii8+PHBhdGggZmlsbD0iIzU0NTg3NCIgZD0iTTE5LjQxNiA0Ny43MDdoNC4yMjdsLjIzNC0zMS40MTRoLTkuNTY4bC0uMjM0IDUuOTc3aC01Ljg3bC4yMzUtMTAuNzg0aDM3LjI3MmwuMjM1IDEwLjc4NEg0MC4wOGwtLjIzNS01Ljk3N2gtOS4zOTJsLS4yMzUgMzEuNDE0aDQuNzU1djQuODA3SDE5LjQxNnoiLz48L2c+PC9nPjwvc3ZnPg==";
export { SvgText as ReactComponent };